import $ from "jquery";
// eslint-disable-next-line
import LazyLoad from "vanilla-lazyload";
// eslint-disable-next-line
let lazy = new LazyLoad();

function defaultPostHeight() {
  $(".post__container").each(function () {
    $(this).removeAttr("style");
  });
  $(".archive__container").removeAttr("style");
}

function generatePostHeight(colum) {
  var elheight = 0, elheight2 = 0, elheight3 = 0, left = 0;
  $(".post__container").each(function () {
    let space = $(window).width() > 1365 ? 50 : 10;
    if (left == 0) {
      $(this).removeAttr("style").css({
        position: "absolute",
        left: left + "px",
        top: elheight + "px",
      });
      elheight = elheight + $(this).height() + space;
    } else if (left == 1) {
      $(this).removeAttr("style").css({
        position: "absolute",
        left: "400px",
        top: elheight2 + "px",
      });
      elheight2 = elheight2 + $(this).height() + space;
    } else if (left == 2) {
      $(this).removeAttr("style").css({
        position: "absolute",
        left: "800px",
        top: elheight3 + "px",
      });
      elheight3 = elheight3 + $(this).height() + space;
    }
    left < (colum-1) ? left++ : (left = 0);
  });

  $(".archive__container").height(elheight > elheight2 ? elheight : elheight2);
}

if ($(window).width() >= 778 && $(window).width() < 1200) {
  generatePostHeight(2);
} else if ($(window).width() >= 1200) {
  generatePostHeight(3);
}

$(window).resize(function () {
  if ($(window).width() < 778) {
    defaultPostHeight();
  } else if ($(window).width() >= 778 && $(window).width() < 1200) {
    generatePostHeight(2);
  } else {
    generatePostHeight(3);
  }
});
